import {
  HOUSING_TYPES,
  INTAKES_MAP,
  PROGRAM_TYPES,
} from "../../program/constants";

export const replaceForURLOptions = (data) => {
  const URLOptions = {} as any;

  if (data.degree) {
    URLOptions.degree = {
      id: data.degree.id,
      name: data.degree.name,
    };
  }

  if (data.major) {
    URLOptions.major = {
      id: data.major.id,
      name: data.major.name,
    };
  }

  if (data.grade) {
    URLOptions.grade = {
      id: data.grade.id,
      name: data.grade.name,
    };
  }

  if (data.programType) {
    URLOptions.programType = data.programType.id;
  }

  if (data.housingType) {
    URLOptions.housingType = data.housingType.id;
  }

  if (data.intake) {
    URLOptions.intake = data.intake.id;
  }

  return URLOptions;
};

export const replaceForFilterForm = (data) => {
  const filterForm = {} as any;

  if (data.degree) {
    filterForm.degree = {
      id: data.degree.id,
      name: data.degree.name,
    };
  }

  if (data.major) {
    filterForm.major = {
      id: data.major.id,
      name: data.major.name,
    };
  }

  if (data.grade) {
    filterForm.grade = {
      id: data.grade.id,
      name: data.grade.name,
    };
  }

  if (data.programType) {
    filterForm.programType = {
      id: data.programType,
      name: PROGRAM_TYPES.find((type) => type.id === data.programType)!.name,
    };
  }

  if (data.housingType) {
    filterForm.housingType = {
      id: data.housingType,
      name: HOUSING_TYPES.find((type) => type.id === data.housingType)!.name,
    };
  }

  if (data.intake) {
    filterForm.intake = {
      id: data.intake,
      name: INTAKES_MAP[data.intake],
    };
  }

  return filterForm;
};
